<div class="container mt-1">
  <div class="card">
    <div class="card-body" style="font-size: 12px;">
      <p>
        Please note that this report requires specific conditions to function
        correctly. <br />
        In the product, the status should not match any of the following values:
        'AE_Assigned', 'Cancelled', 'Commited', 'Expired', 'Published',
        'Terminated', 'Removed_From_Sale', or 'Draft'.<br />
        Additionally, both the book type and product type fields are mandatory
        and should not be left blank.
      </p>
    </div>
  </div>
</div>
<br />
